export const STUDENTS_DECLARATIONS = 'STUDENTS_DECLARATIONS'

export const INCOME_TAX_DECLARATIONS = 'INCOME_TAX_DECLARATIONS'